export default "__VITE_ASSET__DYSuD4OM__"